module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weather-fill clearfix"
  }, [_c('el-form', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label-width": "20px",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("风险等级：")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.form.riskLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "riskLevel", $$v)
      },
      expression: "form.riskLevel"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("较大")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3,
      "disabled": ""
    }
  }, [_vm._v("重大")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("是否涉及简化备案：")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.form.simplifyFlag),
      callback: function($$v) {
        _vm.$set(_vm.form, "simplifyFlag", $$v)
      },
      expression: "form.simplifyFlag"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("不涉及")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("涉及，不产生危险废物，所有Q值累计值小于1")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 3,
      "disabled": ""
    }
  }, [_vm._v("涉及，产生危险废物，所有Q值累计值小于1且年产生危险废物小于10吨")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 4,
      "disabled": ""
    }
  }, [_vm._v("回顾性简化备案")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("厂区面积：" + _vm._s(_vm.form.factoryArea)), _c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v("平方米")])])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("从业人数：" + _vm._s(_vm.form.employeesNum) + " "), _c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v("人")])])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "arr_b",
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("可能发生突发环境事件情景：")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.checkList),
      callback: function($$v) {
        _vm.checkList = $$v
      },
      expression: "checkList"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("火灾、爆炸、泄漏等生产安全事故及可能引起的次生、衍生 厂外环境污染及人员伤亡事故（例如，因生产安全事故导致有毒有 害气体扩散出厂界，消防水、物料泄漏物及反应生成物，从雨水排 口、清净下水排口、污水排口、厂门或围墙排出厂界，污染环境等）")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("环境风险防控设施失灵或非正常操作（如雨水阀门不能正常 关闭，化工行业火炬意外灭火）")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("非正常工况（如开、停车等）;")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "4",
      "disabled": ""
    }
  }, [_vm._v("污染治理设施非正常运行;")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "5",
      "disabled": ""
    }
  }, [_vm._v("违法排污；")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "6",
      "disabled": ""
    }
  }, [_vm._v("停电、断水、停气等;")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "7",
      "disabled": ""
    }
  }, [_vm._v("通讯或运输系统故障;")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "8",
      "disabled": ""
    }
  }, [_vm._v("各种自然灾害、极端天气或不利气象条件；")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "9",
      "disabled": ""
    }
  }, [_vm._v("其他可能的情景。")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30ae03ba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/digtization/infovue.vue
// module id = 1202
// module chunks = 2